import { useXHR } from "@sembark-travel/xhr"
import {
	NewKnowlarityIntegrationForm,
	type TIntegration,
} from "../../../../Integrations"
import { Box, Container, Stack } from "@sembark-travel/ui-base"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { generatePath, useNavigate } from "../../../../router-utils"

export default function NewKnowlarityIntegrationPage() {
	const xhr = useXHR()
	const navigate = useNavigate()
	return (
		<>
			<Helmet>
				<title>New Knowlarity Integration</title>
			</Helmet>
			<Breadcrumbs
				title="New Integration"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					["", "Knowlarity Integration"],
				]}
			/>
			<Box paddingX="4" paddingY="8">
				<Box maxWidth="3xl" marginX="auto">
					<Box borderWidth="1" rounded="md" bgColor="default">
						<Container paddingY="6">
							<Stack gap="4">
								<NewKnowlarityIntegrationForm
									initialValues={{
										name: "Knowlarity",
										description: "Inbound calls via Knowlarity",
									}}
									onSubmit={async (values) => {
										const integration = await xhr
											.post<{ data: TIntegration }>("integrations", {
												...values,
												platform: "tc_knowlarity",
											})
											.then((resp) => resp.data.data)
										navigate("/integrations/:integrationId", {
											params: {
												integrationId: integration.uid,
											},
											replace: true,
										})
									}}
									onCancel={() => {
										navigate("/org/integrations", { replace: true })
									}}
								/>
							</Stack>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
